import Http from '@/utils/axios'

//获取源文章分类列表信息
export const getCateList = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Article.getCateList', param: params });
//获取商家文章列表
export const getList = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Article.getList', param: params });

//获取源文章列表信息
export const getOriArticleList = (params) => new Http({ Addressname: 'tapi',version:'v2.0' }).require({ api: 'Article.getOriArticleList', param: params });
//轮播图
export const bannerList = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Article.getHotVideoList', param: params });
//轮播图
// export const bannerList = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Banner.list', param: params });


export const getSetCard = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'StoreGroup.setting', param: params });



// 获取商家名片信息
export const CardgetCard = (params) => new Http({ Addressname: 'tapi',version:'v3.0' }).require({ api: 'Card.getCard', param: params });

//获取商家文章列表


//商家客户列表
export const StoreMembersList = (params) => new Http({ Addressname: 'tapi','version':'v2.0' }).require({ api: 'StoreMembers.getList', param: params });
//获取用户备注列表信息
export const getRemarkList = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'StoreMembers.getRemarkList', param: params });
//获取客户浏览足迹
export const getMemberLogsList = (params) => new Http({ Addressname: 'tapi','version':'v2.0' }).require({ api: 'StoreMembers.getMemberLogsList', param: params });
//商家给客户添加备注信息	
export const addRemark = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'StoreMembers.addRemark', param: params });
// 购课用户列表
export const getBuyCourseUser = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'StoreCourse.getCourseUserList', param: params });
//获取文章上线状态	
export const getStatus = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Article.getStatus', param: params });
//商家文章状态设置
export const setArticleStatus = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Article.setArticleStatus', param: params });
//获取商家文章分享信息
export const getShareInfo = (params) => new Http({ Addressname: 'tapi',version:"v2.0" }).require({ api: 'Article.getShareInfo', param: params });
//获取海报地址
export const getArticlePoster = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'StoreGroup.getArticlePoster', param: params });

//获取商家基本信息
export const getBasicInfo = (params) => new Http({ Addressname: 'tapi',version:'v2.0' }).require({ api: 'StoreMembers.getBasicInfo', param: params });
//获取源文章详情信息
export const getOriArticleInfo = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Article.getOriArticleInfo', param: params });
//添加群发
export const sendWxMsg = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'StoreGroup.sendWxMsg', param: params });


export const opening = (params) => new Http({ Addressname: 'tapi',version:'v2.0' }).require({ api: 'base.opening', param: params });
//图片上传
export const saveImages = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'Base.saveImages', param: params });

// 判断用户是否开通协议
export const isOpen = (params) => new Http({ Addressname: 'tapi' }).require({ api: 'base.isOpen', param: params });
// 获取开通协议页面的 视频封面图 以及 帮助中心链接
export const getHelpVideo = (params) => new Http({version:'v1.0'}).require({api: 'Base.getHelpVideo',param:params});
// 获取购课记录
export const buyCourseList = (params) => new Http().require({api: 'StoreCourse.buyCourseList',param:params});



// 我的客户客户详情  浏览记录
export const ArticlgetMemberLogsList = (params) => new Http().require({api: 'Article.getMemberLogsList',param:params});

//客户详情   买票记录 b

export const StoreTicketBuyTicketList = (params) => new Http().require({api: 'StoreTicket.buyTicketList',param:params});

//客户详情   买票记录 c

export const TicketBuyTicketList = (params) => new Http().require({api: 'Ticket.buyTicketList',param:params});
